import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthCard } from "@/components/AuthCard";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard subtitle="Mot de passe oublié">
      {sent ? (
        <div className="space-y-5" data-testid="forgot-sent">
          <p className="flex gap-2 rounded-lg bg-primary/10 px-3 py-3 text-sm"><MailCheck className="h-5 w-5 shrink-0 text-primary" /> {sent}</p>
          <p className="text-xs text-muted-foreground">Pensez à regarder dans les spams ou l'onglet « Promotions ».</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <p className="text-sm text-muted-foreground">Indiquez l'adresse de votre compte : vous recevrez un lien pour choisir un nouveau mot de passe.</p>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" />
          </div>
          {error && <p className="rounded-lg bg-destructive/15 px-3 py-2 text-sm text-destructive" data-testid="forgot-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="forgot-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Envoyer le lien
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-5 flex items-center justify-center gap-1 text-sm text-muted-foreground hover:text-primary" data-testid="back-to-login-link">
        <ArrowLeft className="h-4 w-4" /> Retour à la connexion
      </Link>
    </AuthCard>
  );
}
